<div class="card-body-modal">
  <h2 class="mb14">Toegang intrekken</h2>
  <div class="spacer-small"></div>
  <p>Weet je zeker dat je de toegang tot de rapportages van de rechthebbende wilt intrekken?</p>
  <div class="spacer"></div>
  <div class="flex space-between">
    <button (click)="cancel()" class="btn arrow-left btn-left">annuleer</button>
    <button (click)="revoke()" *ngIf="!isLoading" class="btn accent warning times">toegang intrekken</button>
  </div>
</div>
